import { takeEvery, select, put } from 'redux-saga/effects';
import { getPagesHistoryArray } from '../PagesHistory/selectors';
import { getType } from 'typesafe-actions';
import { getUserBadges } from './selectors';
import { getNewAchievedWritingBadges } from './Logic';
import { toast } from 'react-toastify';
import * as React from 'react';
import { unlockBadge, onBadgesChanged, syncBadges } from './actions';
import { getStreakInfo } from '../../components/StreakInfo/StreakLogic';
import { Badge, BadgeId, BadgesStats } from './Models';
import { getWordsCount } from '../Stats/Logic/Reports';
import { updateUserProfileInfo } from '../UserProfile/actions';
import { getSubscriptionsState } from '../UserProfile/selectors';
import DogeBadge from './AllBadges/doge';
import { ENDPOINTS } from 'src/modules/api/endpoints';
import { createApiRequestSaga } from 'src/modules/api/saga';
import { getAuthToken } from '../Auth/selectors';
import { createPage, updatePage, setPagesHistoryFromExternalSource } from '../PagesHistory/actions';
import { BadgeToastComponent } from '../../components/BadgeToast';

function* calculateAchievedBadgesSaga() {
  const pages = yield select(getPagesHistoryArray);
  const userBadges = yield select(getUserBadges);
  const streakInfo = yield select(getStreakInfo);

  const pageStats: BadgesStats = {
    pagesCount: pages.length,
    wordsCount: getWordsCount(pages) || 0,
    streakInfo,
    todaysPage: pages[pages.length - 1],
  };

  const newAchievedBadges = getNewAchievedWritingBadges(pageStats, userBadges);

  if (newAchievedBadges.length > 0) {
    yield put(
      unlockBadge(
        newAchievedBadges.map(badge => {
          return badge.id;
        }),
      ),
    );
  }

  return newAchievedBadges;
}

function* calculateAndShowAchievedBadgesSaga() {
  const newBadges: ReadonlyArray<Badge> = yield calculateAchievedBadgesSaga();

  newBadges.slice(0, 3).map(badge => {
    toast(<BadgeToastComponent badge={badge} />, {
      autoClose: 10000,
    });
  });
}

function* updateIsSubscribedBadge() {
  const subscription = yield select(getSubscriptionsState);
  const userBadges = yield select(getUserBadges);

  if (!userBadges.includes(BadgeId.doge) && subscription.isSubscribed) {
    yield put(unlockBadge([BadgeId.doge]));

    showBadges([new DogeBadge()]);
  }
}

const showBadges = (badges: ReadonlyArray<Badge>) => {
  badges.slice(0, 3).map(badge => {
    toast(<BadgeToastComponent badge={badge} />, {
      autoClose: 10000,
    });
  });
};

const syncBadgesSaga = createApiRequestSaga({
  actionSuccess: syncBadges.success,
  actionError: syncBadges.failure,
});

function* syncBadgesWithServer() {
  const token = yield select(getAuthToken);

  if (!token) {
    return;
  }

  const userBadges = yield select(getUserBadges);

  yield put(
    syncBadges.request({
      url: ENDPOINTS.USER_PROFILE.BADGES,
      method: 'POST',
      data: userBadges,
    }),
  );
}

export default function* badgesSaga() {
  yield takeEvery(
    [getType(createPage), getType(updatePage), getType(setPagesHistoryFromExternalSource)],
    calculateAndShowAchievedBadgesSaga,
  );

  yield takeEvery([getType(updateUserProfileInfo)], updateIsSubscribedBadge);

  yield takeEvery([getType(onBadgesChanged)], syncBadgesWithServer);
  yield takeEvery([getType(syncBadges.request)], syncBadgesSaga);
}



// WEBPACK FOOTER //
// ./src/containers/Badges/saga.tsx